import React from "react";
import "./Tickets.css";
import AdminTicket from "../AdminTicket/AdminTicket";
import { SERVER_ADDRESS } from "../../../constants";

class Tickets extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: [],
            unreleased: [],
            claimed: [],
            feedback: null
        };


        this.pullActive = this.pullActive.bind(this);
        this.pullUnreleased = this.pullUnreleased.bind(this);
        this.pullClaimed = this.pullClaimed.bind(this);
        this.sendReceipt = this.sendReceipt.bind(this);
        this.sendApproval = this.sendApproval.bind(this);
        this.resetFeedback = this.resetFeedback.bind(this);
        this.renderFeedback = this.renderFeedback.bind(this);
        this.renderActive = this.renderActive.bind(this);
        this.renderUnreleased = this.renderUnreleased.bind(this);
        this.renderClaimed = this.renderClaimed.bind(this);
        this.add = this.add.bind(this);
        this.release = this.release.bind(this);
        this.approve = this.approve.bind(this);
    }

    componentDidMount() {
        this.pullActive();
        this.pullUnreleased();
        this.pullClaimed();
    }

    async pullActive() {
        try {
            let result = await fetch(`${SERVER_ADDRESS}/tickets/available`, {
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json"
                }
            })
            if(result) {
                let active = await result.json();
                this.setState({active});
            }
        } catch(error) {
            console.log(error);
        }        
    }

    async pullUnreleased() {
        try {
            let result = await fetch(`${SERVER_ADDRESS}/tickets/unreleased`, {
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json"
                }
            })
            if(result) {
                let unreleased = await result.json();
                this.setState({unreleased});
            }
        } catch(error) {
            console.log(error);
        } 
    }

    async pullClaimed() {
        try {
            let result = await fetch(`${SERVER_ADDRESS}/tickets/claimed`, {
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json"
                }
            })
            if(result) {
                let claimed = await result.json();
                this.setState({claimed});
            }
        } catch(error) {
            console.log(error);
        } 
    }

    async sendReceipt() {
        let data = JSON.stringify({
            email: document.getElementById("ticket-email").value,
            name: document.getElementById("ticket-name").value, 
            value: document.getElementById("ticket-value").value,
            gameDate: document.getElementById("ticket-date").value,
            donationDate: new Date().toDateString(),
        })
        try {
            let result = await fetch(`${SERVER_ADDRESS}/receipt`, {
                method: "POST",
                body: data,
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json"
                }
            })
            return result;
        } catch(error) {
            console.log(error);
        }
    }

    async sendApproval(email, date, team) {
        let data = JSON.stringify({
            email: email,
            gameDate: date,
            teamName: team,
        })
        try {
            let result = await fetch(`${SERVER_ADDRESS}/notify`, {
                method: "POST",
                body: data,
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json"
                }
            })
            return result;
        } catch(error) {
            console.log(error);
        }
    }

    resetFeedback() {
        this.setState({feedback: null});
    }

    renderFeedback() {
        if(!this.state.feedback) {
            return(<p className="feedback positive none">Ticket successfully added!</p>);
        } else if (this.state.feedback === "clear") {
            setTimeout(this.resetFeedback, 5000)
            return (
                <p className="feedback positive">Ticket successfully added!</p>
            )
        } else {
            setTimeout(this.resetFeedback, 15000)
            return (
                <p className="feedback negative">Error adding ticket, please retry inputs.</p>
            )
        }
    }

    renderActive() {
        let returned;
        if(this.state.active[0]) {
            returned = this.state.active.map(ticket => {
                return <AdminTicket key={ticket.id} ticket={ticket} approve={this.approve}/>
            })
        } else {
            returned = <p>No active tickets to display.</p>
        }
        return returned;
    }

    renderUnreleased() {
        let returned;
        if(this.state.unreleased[0]) {
            returned = this.state.unreleased.map(ticket => {
                return <AdminTicket key={ticket.id} ticket={ticket} release={this.release}/>
            })
        } else {
            returned = <p>No unreleased tickets to display.</p>
        }
        return returned;
    }

    renderClaimed() {
        let returned;
        if(this.state.claimed[0]) {
            returned = this.state.claimed.map(ticket => {
                return <AdminTicket key={ticket.id} ticket={ticket}/>
            })
        } else {
            returned = <p>No claimed tickets to display.</p>
        }
        return returned;
    }

    async add() {
        let date = new Date().toDateString();
        let rawData = {
            donor_email: document.getElementById("ticket-email").value,
            donor_name: document.getElementById("ticket-name").value,
            donor_company: document.getElementById("ticket-organization").value,
            ticket_team: document.getElementById("ticket-team").value,
            ticket_date: document.getElementById("ticket-date").value,
            ticket_value: document.getElementById("ticket-value").value,
            seat_section: document.getElementById("ticket-section").value,
            seat_row: document.getElementById("ticket-row").value,
            seat_numbers: document.getElementById("ticket-seats").value,
            donation_date: date,
            released: (document.getElementById("ticket-release").checked ? true : false)
        }
        let data = JSON.stringify(rawData);
        try {
            let result = await fetch(`${SERVER_ADDRESS}/tickets`, {
                method: "POST",
                body: data,
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json"
                }
            })
            if(result) {
                result = await result.json();
                result = await this.sendReceipt();
            }

            document.getElementById("ticket-email").value = "";
            document.getElementById("ticket-name").value = "";
            document.getElementById("ticket-organization").value = "";
            document.getElementById("ticket-team").value = "";
            document.getElementById("ticket-date").value = "";
            document.getElementById("ticket-value").value = "";
            document.getElementById("ticket-section").value = "";
            document.getElementById("ticket-row").value = "";
            document.getElementById("ticket-seats").value = "";
            document.getElementById("ticket-release").checked = false;
            
            this.setState({feedback: "clear"});
            if(rawData.released) {
                this.pullActive();
            } else {
                this.pullUnreleased();
            }
            
        } catch(error) {
            this.setState({feedback: "bad"});
            console.log(error);
        }
    }

    async release(event) {
        let id = event.target.parentNode.children[0].id;
        console.log(id);
        try {
            let result = await fetch(`${SERVER_ADDRESS}/tickets/release/${id}`, {
                method: "PUT",
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json"
                }
            })
            if(result) {
                this.pullActive();
                this.pullUnreleased();
            }
        } catch(error) {
            console.log(error);
        }
    }

    async approve(user, id, date, team) {
        try {
            let result = await fetch(`${SERVER_ADDRESS}/tickets/request/${id}/approve`, {
                method: "PUT",
                body: JSON.stringify({claimer: user}),
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json"
                }
            })
            if(result) {
                result = await this.sendApproval(user, date, team)

                this.pullActive();
                this.pullClaimed();
            }
        } catch(error) {
            console.log(error);
        }
    }

    render() {
        return (
            <div id="ticket-page">
                <div id="register">
                    <h2>Register Tickets</h2>
                    <table id="ticket-registration">
                        <tbody>
                            <tr className="add-bottom input-container" id="ticket-name-container">
                                <td className="input-label">Name:</td>
                                <td>
                                    <input className="input-register"  id="ticket-name" placeholder="ex: John Doe"/>
                                </td>
                                <td></td>
                            </tr>

                            <tr className="add-bottom input-container" id="ticket-email-container">
                                <td className="input-label">Email:</td>
                                <td>
                                    <input className="input-register"  id="ticket-email" placeholder="ex: kis@gmail.com"/>
                                </td>
                                <td></td>
                            </tr>

                            <tr className="add-bottom input-container" id="ticket-organization-container">
                                <td className="input-label">Organization:</td>
                                <td>
                                    <input className="input-register"  id="ticket-organization" placeholder="ex: Kids in Seats"/>
                                </td>
                                <td></td>
                            </tr>

                            <tr className="divide add-bottom input-container" id="ticket-team-container">
                                <td className="input-label">Ticket Team:</td>
                                <td>
                                    <input className="input-register"  id="ticket-team" placeholder="ex: Yankees"/>
                                </td>
                                <td></td>
                            </tr>

                            <tr className="add-bottom input-container" id="ticket-date-container">
                                <td className="input-label">Ticket Date:</td>
                                <td>
                                    <input className="input-register"  id="ticket-date" placeholder="ex: MM/DD/YYYY"/>
                                </td>
                                <td></td>
                            </tr>

                            <tr className="add-bottom input-container" id="ticket-value-container">
                                <td className="input-label">Ticket Value:</td>
                                <td>
                                    <input className="input-register"  id="ticket-value" placeholder="ex: 450"/>
                                </td>
                                <td></td>
                            </tr>

                            <tr className="divide add-bottom input-container" id="ticket-section-container">
                                <td className="input-label">Ticket Section:</td>
                                <td>
                                    <input className="input-register"  id="ticket-section" placeholder="ex: A"/>
                                </td>
                                <td></td>
                            </tr>

                            <tr className="add-bottom input-container" id="ticket-row-container">
                                <td className="input-label">Ticket Row:</td>
                                <td>
                                    <input className="input-register"  id="ticket-row" placeholder="ex: 32"/>
                                </td>
                                <td></td>
                            </tr>

                            <tr className="add-bottom input-container" id="ticket-seats-container">
                                <td className="input-label">Ticket Seats:</td>
                                <td>
                                    <input className="input-register"  id="ticket-seats" placeholder="ex: 12-15"/>
                                </td>
                                <td></td>
                            </tr>

                            <tr className="add-bottom input-container" id="ticket-release-container">
                                <td className="input-label">Release? </td>
                                <td>
                                    <input className="input-register" id="ticket-release" type="checkbox"/>
                                </td>
                                <td></td>
                            </tr>
                            
                        </tbody>
                    </table>
                    <p className="allowed" onClick={this.add} id="ticket-button">Go</p>
                    {this.renderFeedback()}
                </div>
                <div className="tickets-container" id="active-tickets">
                    <h2>Active Tickets</h2>
                    <div className="ticket-display">
                        {this.renderActive()}
                    </div>
                </div>

                <div className="tickets-container" id="unreleased-tickets">
                    <h2>Unreleased Tickets</h2>
                    <div className="ticket-display">
                        {this.renderUnreleased()}
                    </div>
                </div>

                <div className="tickets-container" id="claimed-tickets">
                    <h2>Claimed Tickets</h2>
                    <div className="ticket-display">
                        {this.renderClaimed()}
                    </div>
                </div>              

            </div>
        );
    }
}

export default Tickets;